import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/check-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM400 432H48V80H400V432zM364.1 190.3L191.5 361.5C186.8 366.1 179.2 366.1 174.6 361.4L83.8 269.9C79.1 265.2 79.2 257.6 83.9 252.9L106.6 230.4C111.3 225.7 118.9 225.8 123.6 230.5L183.3 290.7 324.7 150.5C329.4 145.9 337 145.9 341.7 150.6L364.2 173.3C368.9 178 368.8 185.6 364.1 190.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/check-square.js
// module id = iQwv
// module chunks = 144